<style type="text/css">
  .el-icon-arrow-up {width: 1em;font-size: 0.9em;}
  .el-icon-arrow-up::before {color: black; font-weight: bold;}

</style>
<template lang="pug">
  div.registry.object-update
    e-form-modal(
      ref="modalForm"
      @submitModalForm="sendForm()"
      @deleteItem="deleteItem()"
      :showSaveButton="showSaveButton"
      :hideDeleteButton="hideDeleteButton"
    )
      div(slot="header")
        e-breadcrumbs
        h1.title {{formTitle}}
        e-form-tabs(
          v-model="tabView"
          :tabs="tabs"
        )
      slot
        e-form(:formValidator="formValidator")
          // вкладка ОБЩИЕ СВЕДЕНИЯ
          div(v-show="tabView === 'tab1'")
            div.body
              div.col
                e-form-group(
                  name="name"
                  inputType="input"
                  label="Наименование объекта"
                  :model="fields"
                  tabView="tab1"
                  :required="true"
                )
                e-form-group(
                  name="cadastr_number"
                  inputType="input"
                  label="Кадастровый номер земельного участка"
                  :model="fields"
                  tabView="tab1"
                )

                e-form-group(
                  name="post_address"
                  inputType="input"
                  label="Почтовый адрес"
                  :model="fields"
                  tabView="tab1"
                )

                e-form-group(
                  name="is_intermunicipal"
                  :model="fields"
                  tabView="tab1"
                  caption="Межмуниципальный"
                  inputType="checkbox"
                )

                e-form-group(
                  name="is_mps"
                  :model="fields"
                  tabView="tab1"
                  caption="МПС"
                  inputType="checkbox"
                )

                e-form-group(
                  name="tkoActions"
                  :model="fields"
                  tabView="tab1"
                  label="Назначение объекта"
                  :options="ACTIONS"
                  optionValueKey="tko_action_id"
                  optionTextKey="label"
                  inputType="checkbox[]"
                )

                e-form-group(
                  formGroupStyle="col-block multitags"
                  name="garbage_groups"
                  :model="fields"
                  tabView="tab1"
                  label="Группы обслуживаемых отходов"
                  :options="garbageGroupsOptions"
                  inputType="suggestion[]"
                )

              div.col
                e-form-group(
                  name="status_id"
                  inputType="select"
                  label="Статус объекта"
                  :model="fields"
                  :options="statuses"
                  :required="true"
                  :disabled="statusDisabled"
                  tabView="tab1"
                )

                div.col-block
                  label Год ввода в эксплуатацию
                  el-select(
                    v-model='fields.object_date_start'
                    placeholder='Выберите один из вариантов'
                    title='Год ввода в эксплуатацию'
                    :filterable='true'
                    :default-first-option='true'
                  )
                    el-option(
                      v-for='item in operationYear'
                      :key = 'item.id'
                      :label= 'item.name'
                      :value ='item.id'
                    )
                div.col-block
                  label Год окончания эксплуатации
                  el-select(
                    v-model='fields.object_date_finish'
                    placeholder='Выберите один из вариантов'
                    title='Год окончания эксплуатации'
                    :filterable='true'
                    :default-first-option='true'
                  )
                    el-option(
                      v-for='item in operationYear'
                      :key = 'item.id'
                      :label= 'item.name'
                      :value ='item.id'
                    )

                e-form-group(
                  name="area"
                  inputType="input"
                  label="Площадь земельного участка, в Га"
                  :model="fields"
                  tabView="tab1"
                )
              div.col
                e-location(
                  :formValidator="formValidator"
                  :model="fields"
                  name="address"
                  :required="true"
                  :addressData="addressData"
                  :freezeLatLng="isFieldDisabled('location')"
                  tabView="tab1"
                )

                e-form-group(
                  name="orientir_distance"
                  inputType="input"
                  label="Расстояние до ближайшего населенного пункта, км"
                  :model="fields"
                  tabView="tab1"
                )
                e-form-group(
                  name="orientir"
                  inputType="input"
                  label="Ориентир"
                  :model="fields"
                  tabView="tab1"
                )
                e-form-group(
                  name="photoPreview"
                  inputType="simple-file-uploader"
                  label="Фотография"
                  :model="fields"
                  tabView="tab1"
                  :uploadUrl="uploadUrl"
                  @fileUploaded="fileUploaded"
                  @fileRemoved="fileRemoved"
                  :showFilePreview="true"
                )

            e-modal(v-if="showFullOperatorSelectTable"
              @close="showFullOperatorSelectTable = false"
              @confirm="saveFullOperator()"
              title="Выбор эксплуатирующей организации"
            )
              slot
                e-table-checked-list(
                  selectType="radio"
                  ref="fullOperatorSelectTable"
                  @checkedChange="fullOperatorUpdate($event)"
                  :endpoint="endpointFullOperatorList"
                  :earlyCheckedItems="getEarlyCheckedFullOperator()"
                  :showPaginate="true"
                  :listTypes="fullOperatorTypes"
                  defaultListType="operator"
                )

            div.body.body-table
              div.table-choose-panel
                div.toolbar-table
                  div.select Эксплуатирующая организация
                  //toolbarBlockClear
                  // должна остаться вот такая структура:
                  div.toolbar.toolbar--modal
                    div.line
                      // добавлен модификатор .search--rounded
                      div.actions-panel
                        e-button-edit(v-if="!objectFormDisabled" @click="showFullOperatorSelectTable=!showFullOperatorSelectTable")
                        //button(v-if="!objectFormDisabled" @click="showFullOperatorSelectTable=!showFullOperatorSelectTable").actions-panel__button.btn-edit

                div.table
                  table
                    thead
                      th Наименование
                      th ИНН
                      th Юр. адрес
                      th Местоположение
                      th Код в кадастре
                      th № лицензии
                      th Срок действия
                      th
                    tbody
                      tr(v-if="fields.tko_operator && fields.tko_operator.id")
                        td
                          router-link(
                            :to="getOperatorRoute(fields.tko_operator)"
                            v-html="fields.tko_operator.name"
                          )
                        td {{fields.tko_operator.inn}}
                        td {{fields.tko_operator.address}}
                        td {{fields.tko_operator.fact_address}}
                        td {{fields.tko_operator.cadastr_code}}
                        td {{fields.tko_operator.license_number}}
                        td {{fields.tko_operator.license_start_date ? 'с ' + fields.tko_operator.license_start_date : ''}} {{fields.tko_operator.license_finish_date ? 'по ' + fields.tko_operator.license_finish_date : ''}}
                        td
                          e-button-delete(v-if="!objectFormDisabled" @click="deleteFullOperator()")
                          //button(v-if="!objectFormDisabled" @click="deleteFullOperator()").row-delete
                      tr(v-else)
                        td(colspan=100) Эксплуатирующая организация отсутствует

          // ТАРИФЫ
          tko-tariff(
            v-show="tabView === 'tariffs'"
            :tkoOperatorTariffs="fields.tkoObjectTariffs"
            :entityId="fields.id"
            ref="tkoTariff"
            :TARIFFS="TARIFFS"
          )

            // вкладка ТЕХНОЛОГИИ
          div(v-show="tabView === 'tab2'")
            technology-table(
              :id="fields.id"
              :itemId="itemId"
              :formDisabled="objectFormDisabled"
              ref="technologyTable"
              tabView="tab2")

          //РАЗМЕЩЕНИЕ
          div(v-show="tabView === 'tab3'")
            div.body
              div.col
                e-form-subtitle(text="Характеристика объекта размещения отходов")

                e-form-group(
                  name="coefficient_compaction"
                  label="Коэффициент уплотнения"
                  :model="fields"
                  validationRule="double"
                  tabView="tab3"
                  v-if="fields.tkoActions.indexOf(TransportationId) > -1"
                )
                e-form-group(
                  name="part_secondary"
                  label="Доля отбора вторичных материальных ресурсов"
                  :model="fields"
                  validationRule="number"
                  tabView="tab3"
                  v-if="fields.tkoActions.indexOf(TransportationId) > -1 || fields.tkoActions.indexOf(ProcessingId) > -1"
                  :validationAdditionalRules="{minValue: 0, maxValue: 100}"
                )
                e-form-group(
                  name="part_fuel_production"
                  :label="textes.part_fuel_production"
                  :model="fields"
                  validationRule="double"
                  tabView="tab3"
                  v-if="fields.tkoActions.indexOf(ProcessingId) > -1"
                  :validationAdditionalRules="{minValue: 0, maxValue: 100}"
                )

                e-form-group(
                  name="tko_object_type_id"
                  inputType="select"
                  label="Вид объекта"
                  :model="fields"
                  :options="tkoObjectTypeOptions"
                  tabView="tab3"
                )
                e-form-group(
                  name="tko_object_state_id"
                  inputType="select"
                  label="Состояние объекта"
                  :model="fields"
                  :options="tkoObjectStateOptions"
                  tabView="tab3"
                )

                e-form-group(
                  name="area_garbage"
                  label="Площадь участка под рамещение отходов, га"
                  :model="fields"
                  validationRule="double"
                  tabView="tab3"
                )
                e-form-group(
                  name="power"
                  label="Мощность, тыс. тонн/год"
                  :model="fields"
                  validationRule="double"
                  tabView="tab3"
                )
                e-form-group(
                  name="project_capacity"
                  label="Вместимость (проектная), тыс. тонн"
                  :model="fields"
                  validationRule="double"
                  tabView="tab3"
                )
                e-form-group(
                  name="leftover_capacity"
                  label="Вместимость (остаточная), тыс. тонн"
                  :model="fields"
                  validationRule="double"
                  tabView="tab3"
                )
                e-form-group(
                  name="operation_period"
                  label="Остаточный срок эксплуатации объекта, лет"
                  :model="fields"
                  validationRule="double"
                  tabView="tab3"
                  :disabled="true"
                )

              div.col
                e-form-subtitle(text="Документация")
                e-form-group(
                  name="has_doc_building"
                  :model="fields"
                  tabView="tab3"
                  label="Проектная документация на строительство объекта"
                  inputType="radio"
                  :options="yeasOrNo"
                )

                e-form-group(
                  name="has_doc_recultivation"
                  :model="fields"
                  tabView="tab3"
                  label="Проектная документация на рекультивацию земельного участка"
                  inputType="radio"
                  :options="yeasOrNo"
                )

                e-form-group(
                  name="has_expertise"
                  :model="fields"
                  tabView="tab3"
                  label="Положительное заключение гос. экологической экспертизы"
                  inputType="radio"
                  :options="yeasOrNo"
                )

                e-form-group(
                  name="number"
                  label="Номер документа"
                  :model="fields.tkoObjectExpertize"
                  :disabled="disableEditExpertize"
                  :required="!disableEditExpertize"
                  validationRule="number"
                  tabView="tab3"
                  validateAlias="tkoObjectExpertize.number"
                )
                e-form-group(
                  name="dt"
                  input-type="calendar"
                  label="От"
                  :model="fields.tkoObjectExpertize"
                  :disabled="disableEditExpertize"
                  :required="!disableEditExpertize"
                  validationRule="number"
                  tabView="tab3"
                  validateAlias="tkoObjectExpertize.dt"
                )
                e-form-group(
                  name="organization"
                  label="Выдавшая организация"
                  :model="fields.tkoObjectExpertize"
                  :disabled="disableEditExpertize"
                  :required="!disableEditExpertize"
                  tabView="tab3"
                  validateAlias="tkoObjectExpertize.organization"
                )


              div.col
                e-form-subtitle(text="ГРОРО")

                e-form-group(
                  name="has_groro"
                  :model="fields"
                  tabView="tab3"
                  label="Включение объекта в ГРОРО"
                  inputType="radio"
                  :options="yeasOrNo"
                )

                e-form-group(
                  name="dt"
                  input-type="calendar"
                  label="От"
                  :disabled="disableEditGroro"
                  :required="!disableEditGroro"
                  :model="fields.tkoObjectIngroro"
                  validationRule="number"
                  tabView="tab3"
                  validateAlias="tkoObjectIngroro.dt"
                )
                e-form-group(
                  name="number"
                  label="Номер документа"
                  :disabled="disableEditGroro"
                  :required="!disableEditGroro"
                  :model="fields.tkoObjectIngroro"
                  tabView="tab3"
                  validateAlias="tkoObjectIngroro.number"
                )
                e-form-group(
                  name="groro_number"
                  label="Номер ГРОРО"
                  :disabled="disableEditGroro"
                  :required="!disableEditGroro"
                  :model="fields.tkoObjectIngroro"
                  tabView="tab3"
                  validateAlias="tkoObjectIngroro.groro_number"
                )


          //ДОКУМЕНТЫ
          div(v-show="tabView === 'tab4'")
            div.body
              div.col
                e-form-subtitle(text="На земельный участок")
                e-form-group(
                  label="Свидетельство регистрации права, номер"
                  name="number"
                  validationRule="number"
                  :model="registrationDocumentsModel['1']"
                  tabView="tab4"
                )
                e-form-group(
                  label="От"
                  inputType="calendar"
                  name="date_start"
                  :model="registrationDocumentsModel['1']"
                  tabView="tab4"
                )


                e-form-group(
                  label="Договор аренды, номер"
                  validationRule="number"
                  name="number"
                  :model="registrationDocumentsModel['2']"
                  tabView="tab4"
                )
                e-form-group(
                  label="От"
                  inputType="calendar"
                  name="date_start"
                  :model="registrationDocumentsModel['2']"
                  tabView="tab4"
                )
                e-form-group(
                  label="Срок действия до"
                  inputType="calendar"
                  name="date_finish"
                  :model="registrationDocumentsModel['2']"
                  tabView="tab4"
                )


              div.col
                e-form-subtitle(text="На установку")

                e-form-group(
                  label="Свидетельство регистрации права, номер"
                  validationRule="number"
                  name="number"
                  :model="registrationDocumentsModel['3']"
                  tabView="tab4"
                )
                e-form-group(
                  label="От"
                  inputType="calendar"
                  name="date_start"
                  :model="registrationDocumentsModel['3']"
                  tabView="tab4"
                )


                e-form-group(
                  label="Договор аренды, номер"
                  validationRule="number"
                  name="number"
                  :model="registrationDocumentsModel['4']"
                  tabView="tab4"
                )
                e-form-group(
                  label="От"
                  inputType="calendar"
                  name="date_start"
                  :model="registrationDocumentsModel['4']"
                  tabView="tab4"
                )
                e-form-group(
                  label="Срок действия до"
                  inputType="calendar"
                  name="date_finish"
                  :model="registrationDocumentsModel['4']"
                  tabView="tab4"
                )

              div.col




          // вкладка СВЕДЕНИЯ ПО ОТХОДАМ
          div(v-show="tabView === 'tab5'")
            p
            r-registry-object-garbage-table(
              :fields="fields"
              :id="fields.id"
              :itemId="itemId"
              :formDisabled="objectFormDisabled"
              ref="garbageTable"
              tabView="tab5"
            )

          // вкладка Х-КА
          div(v-show="tabView === 'tab6'")
            div.body
              div.col
                e-form-group(
                  name="has_monitoring"
                  :model="fields"
                  tabView="tab6"
                  label="Наличие систем мониторинга окружающей среды на объекте"
                  inputType="radio"
                  :options="yeasOrNo"
                )

                e-form-group(
                  formGroupStyle="col-block multitags"
                  name="road_types"
                  :model="fields"
                  tabView="tab6"
                  label="Характеристики подъездных путей"
                  inputType="suggestion[]"
                  :options="specOfAccessRoadsOptions"
                )

              div.col
                e-form-group(
                  name="engineering_systems"
                  :model="fields"
                  tabView="tab6"
                  label="Инженерное обеспечение"
                  inputType="checkbox[]"
                  :options="engineeringSystemOptions"
                )

              div.col

          // Маршруты
          div(v-if="tabView === 'routes'").routes
            routes-table(:fields="fields" :id="fields.id" ref="routesTable" tabView="routes")

          //Журнал изменений
          div(v-show="tabView === 'tab7'")
            change-log-tab(
              :entityId="fields.id"
              :moduleId="moduleId"
            )

          //Документы
          div(v-show="tabView === 'tab8'")
            documents-table(
              :document-ids="documentIds"
              @documentsChanged="documentsChanged"
            )
</template>

<script>
  import { core, tko } from '@/api/api-endpoints'
  import objectForm from './mixins/object-form.js'
  import TechnologyTable from './components/technology-table'
  import RoutesTable from './components/routes-table'
  import TkoTariff from './components/tko-tariff'

  import {ObjectUpdate} from '@/config/texts';

  export default {
    components: {
      TkoTariff,
      RoutesTable,
      TechnologyTable
    },
    mixins: [objectForm],
    data() {
      return {
        errors: null,
        textes: ObjectUpdate,
      }
    },
    computed: {
      // for use in src/app/registry/OperatorAllUpdate.vue
      // with duplicate id route
      itemId() {
        return this.$route.params.objectId || this.$route.params.id || null
      },
      moduleId() {
        return this.moduleIds['tko-object']
      },
      tabs() {
        const tabs = [{ tab1: 'Общие сведения' }, { tab2: 'Технологии' }, { tab3: 'Размещение' }, { tab4: 'Документы' }, { tab5: 'Сведения по отходам' }, { tab6: 'Характеристика' }, { routes: 'Маршруты' }, { tariffs: 'Тарифы' }]
        if (this.fields.id) {
          tabs.push({ tab7: 'Журнал изменений' })
        }
        tabs.push({ tab8: 'Документы' })
        return tabs
      }
    },
    methods: {
      getDocumentsEndpoint(id) {
        return core.documents(id)
      },
      getTkoOperatorEndpoint() {
        return core.statuses({ fields: 'tko_operator' })
      },
      getCollectionEndpoint() {
        return core.collection(
          'garbage_group,status,engineering_system,road_type,tko_object_type,tko_object_state',
          {query: {type: 'tko_object'}}
        )
      },
      getDeleteUrl(id) {
        return tko.objectDelete(id)
      },
      getUpdateOrCreateUrl() {
        let itemId = this.$route.params.objectId || this.$route.params.id || null
        return tko.objectUpdateOrCreate(itemId)
      },
      getItemEndpoint(route) {
        let itemId = route.params.objectId || route.params.id || null
        if (!itemId) {
          return null
        }
        return tko.object(itemId)
      }
    }
  }
</script>
